<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="closeDialog" v-on:input="$emit('updateDialog', $event.target.value)" max-width="750px">
      <template v-slot:activator="{ on }" v-if="show_button">
        <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ GetTitle() }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-12">
                <v-combobox
                  v-model="movementItem.containers"
                  data-vv-as="containers"
                  name="containers"
                  item-text="matricula"
                  item-value="id"
                  :items="containers"
                  label="Contenedor*"
                  autocomplete="off"
                  v-validate="'required'"
                  :disabled="isViewModal() || loading_zones"
                  multiple                      
                  chips
                  small-chips
                  @change="onChangeContainers"
                ></v-combobox>
                <span class="red--text">{{ errors.first("containers") }}</span>
              </div>

              <div class="col-md-12">
                <v-combobox
                  :loading="loading_zones"
                  v-model="movementItem.zone"
                  data-vv-as="zona"
                  name="movementItem.zone"
                  item-text="name"
                  item-value="id"
                  :items="zones"
                  label="Zona*"
                  autocomplete="off"
                  v-validate="'required'"
                  :disabled="isViewModal()|| movementItem.containers.length == 0"                  
                  @change="onChangeZone"
                ></v-combobox>
                <span class="red--text">{{ errors.first("movementItem.zone") }}</span>
              </div>

              <div class="col-md-12" v-if="movementItem.containers.length <= 1">
                <v-combobox
                  v-model="movementItem.location"
                  data-vv-as="ubicacion"
                  name="location"
                  item-text="name"
                  item-value="id"
                  :items="locations"
                  label="Ubicacion*"
                  autocomplete="off"
                  v-validate="'required'"
                  :disabled="isViewModal() || movementItem.zone == null"                  
                ></v-combobox>
                <span class="red--text">{{ errors.first("location") }}</span>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closeDialog">Cerrar</v-btn>
            <v-btn color="success" :loading="submit_loading" text type="submit" v-if="!isViewModal()">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import ModalMixin from "@/mixins/ModalMixin.vue";
export default {
  mixins: [ModalMixin],
  props: {
    parent: Object,    
    modal_title: String,
    dialog: Boolean,
    item: Object,
    selected: Array,
    button_name: String,
    formBtn: String,
    show_button: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: false,           
      zones: [],
      containers: [],
      locations: [],
      movementItem: {                
        containers: [],
        zone: null,
        location: null,
      },
      defaultItem: { 
        containers: [],   
        zone: null,      
        location: null,
      },
      loading_zones: false,
    };
  },
  watch: {
    item() {
      if(this.item != null && this.item.id > 0){        
        this.movementItem.containers = [this.item];
        this.onChangeContainers();
      }else if(this.selected.length > 0){
        this.movementItem.containers = this.selected;
        this.onChangeContainers();
      }
      this.$emit("updateItem", this.item);
    },
    dialog() {
      this.errors.clear();
    },
  },
  mounted() {        
    this.loadComboData();
  },
  methods: {
    GetTitle(){
      if(this.movementItem.containers != null && this.movementItem.containers.length == 1){
        return this.movementItem.containers[0].matricula
      }else{
        return this.movementItem.length + " contenedores seleccionados";
      }
    },
    closeDialog() {
      this.movementItem = JSON.parse(JSON.stringify(this.defaultItem));
      this.$emit("updateDialog", false);
    },
    loadComboData() {      
      generalService.filter({}, Constant.SECTION_CONTAINERS).then((response) => {        
        this.containers = response.result.list;
        if(this.item != null && this.item.id > 0){
          this.movementItem = this.containers.find((element) => element.id == this.item.id);          
        }
      });
    },
    isViewModal() {
      return this.formBtn == "";
    },    
    createItem(e) {
      if(this.loading)
        return;
      this.setLoading(true);   
      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();
        }
                
        generalService.setSection(Constant.SECTION_CONTAINERS+"/massive_move");
        generalService
            .create(this.movementItem)
            .then((response) => {
              if (response.status == true) {
                const prefix = (this.movementItem.containers.length > 1)?"Los ":"El ";
                this.$toast.success(prefix+this.modal_title+" se modifico correctamente.", "OK");
                this.closeDialog();
                this.$emit("loadList");
              } else {
                if(Object.prototype.hasOwnProperty.call(response, 'message')){
                  this.$toast.error(response.message, "Error");
                }else{
                  this.$toast.error(response.msg, "Error");
                }
              }
            })
            .catch((response) => {
              this.$toast.error(response.msg, "Error");
            })
            .finally(()=> this.setLoading(false));
      });
    },
    onChangeZone(){
      if(this.movementItem.zone != null && this.movementItem.zone.id > 0){
        generalService
            .custom_post({ zone_id: this.movementItem.zone.id}, Constant.SECTION_ZONES+"/list/available-locations")
            .then((response) => {
              if (response.status == true) {
                console.log(response.result)
                this.locations = response.result;
              } else {
                if(Object.prototype.hasOwnProperty.call(response, 'message')){
                  this.$toast.error(response.message, "Error");
                }else{
                  this.$toast.error(response.msg, "Error");
                }
              }
            })
            .catch((response) => {
              this.$toast.error(response.msg, "Error");
            })
            .finally(()=> this.setLoading(false));
      }
    },
    onChangeContainers(){      
      //Buscar zonas con this.movementItem.containers.length disponibles      
      if(this.loading_zones)
        return;
      this.zones = [];
      this.loading_zones = true;
      console.log(this.movementItem.containers);
      generalService.filter({ locations_available: this.movementItem.containers.length }, Constant.SECTION_ZONES).then((response) => {
        this.zones = response.result.list;        
      })
      .finally(()=> this.loading_zones = false);
    }
  },
};
</script>
